

export interface GridProps {
  children: React.ReactNode;
  templateColumns?: string; // css 'grid-template-columns'
  gap?: string;
}

export function Grid(props: GridProps) {
  const { children, templateColumns, gap } = props;

  return (
    <div
      style={{
        display: "grid",
        gap,
        gridTemplateColumns: templateColumns,
      }}
    >
      {children}
    </div>
  );
}